// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 1.5V4H2V9H22V4H18V1.5H16V4H8V1.5H6Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22V10.9995H2V22H22Z"}}]};

const CalendarFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-filled',
    ref,
    icon: element,
  },
));

CalendarFilledIcon.displayName = 'CalendarFilledIcon';

export default CalendarFilledIcon;
